import API from "../api";

export default {
  namespaced: true,
  state: {
    listCourt: [],
    totalCourt: 0,
    listRegionCourt: [],
    totalRegionCourt: 0,
    currentCourt: {
      id: null,
      codigo: null,
      nome: null
    },
    segment: [],
    currentRegionCourt: {}
  },
  mutations: {
    setListCourt(state, payload) {
      state.listCourt = payload.items;
      state.totalCourt = payload.total_count;
    },
    setListRegionCourt(state, payload) {
      state.listRegionCourt = payload.items;
      state.totalRegionCourt = payload.total_count;
    },
    setCurrentCourt(state, payload) {
      // Como a ataulização do back demora
      // mais que o combo put+get, só
      // será atualizado apenas se o id
      // for diferente do existente
      state.currentCourt =
        !state.currentCourt.id || state.currentCourt.id != payload.id
          ? payload
          : state.currentCourt;
    },
    setSegment(state, payload) {
      state.segment = payload;
    },
    setCurrentRegionCourt(state, payload) {
      state.currentRegionCourt = payload;
    }
  },
  actions: {
    async requestListCourt({ commit }, payload) {
      const { data } = await API.getCourt(payload);
      commit("setListCourt", data);
      return data;
    },
    async requestListRegionCourt({ commit }, payload) {
      const { data } = await API.getRegionCourt(payload);
      commit("setListRegionCourt", data);
      return data;
    },
    async requestCurrentCourt({ commit }, payload) {
      const { data } = await API.getCurrentCourt(payload);
      commit("setCurrentCourt", data);
      return data;
    },
    async requestEditCourt(context, payload) {
      const { data } = await API.putCourt(payload);
      return data;
    },
    async requestNewCourt(context, payload) {
      const { data } = await API.postCourt(payload);
      return data;
    },
    async requestSegment({ commit }) {
      const { data } = await API.getSegment();
      commit("setSegment", data);
      return data;
    },
    async requestEditRegionCourt(context, payload) {
      const { data } = await API.putRegionCourt(payload);
      return data;
    },
    async requestNewRegionCourt(context, payload) {
      const { data } = await API.postRegionCourt(payload);
      return data;
    },
    async requestCurrentRegionCourt({ commit }, payload) {
      const { data } = await API.getCurrentRegionCourt(payload);
      commit("setCurrentRegionCourt", data);
      return data;
    }
  },
  modules: {}
};
